import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';

import { BehaviorSubject } from 'rxjs';

import { environment } from 'environments/environment';

@Injectable()
export class ForgotPasswordService implements Resolve<any> {
  public showDopplerImageSubject = new BehaviorSubject<boolean>(false);

  resolve(): Promise<any> {
    return new Promise((resolve, reject) => {
      const currentUrl = window.location.href;

      if (currentUrl.startsWith(environment.URL_DOPPLER)) {
        document.body.classList.add('theme-doppler');
        this.showDopplerImageSubject.next(true);
      } else {
        document.body.classList.add('theme-default');
        this.showDopplerImageSubject.next(false);
      }

      resolve(null);
    });
  }
}
